<div class="pdf-page-header">
  <span class="pdf-page-label">Page {{ pageNumber() }} / {{ pageCount() }}</span>
  @if (rotatable()) {
    @let counterclockwiseLabel =
      'Faire pivoter la page ' + pageNumber() + ' dans le sens inverse des aiguilles d’une montre';
    @let clockwiseLabel =
      'Faire pivoter la page ' + pageNumber() + ' dans le sens des aiguilles d’une montre';
    <button
      matIconButton
      [attr.aria-label]="counterclockwiseLabel"
      [matTooltip]="counterclockwiseLabel"
      (click)="turned.emit('counterclockwise')"
    >
      <svg lucideRotateCcw></svg>
    </button>
    <button
      matIconButton
      [attr.aria-label]="clockwiseLabel"
      [matTooltip]="clockwiseLabel"
      (click)="turned.emit('clockwise')"
    >
      <svg lucideRotateCw></svg>
    </button>
  }
</div>
@if (failed()) {
  <div class="pdf-page-error" role="alert">
    <p>La page {{ pageNumber() }} n’a pas pu être affichée.</p>
    <div class="pdf-page-error-actions">
      <button
        matButton="outlined"
        [attr.aria-label]="'Réessayer d’afficher la page ' + pageNumber()"
        (click)="retry()"
      >
        Réessayer
      </button>
      <button
        matButton
        aria-label="Ouvrir le document d’origine dans un nouvel onglet"
        (click)="openOriginal.emit()"
      >
        Ouvrir l’original
      </button>
    </div>
  </div>
}
<canvas
  #canvas
  role="img"
  [class.pdf-page-hidden]="failed()"
  [attr.aria-label]="'Page ' + pageNumber()"
></canvas>
